import { useMemo } from "react";
import { usePathname } from "expo-router";
import { NAVIGATION_MENU_ITEMS } from "../constants/NavigationMenuItems";
import { usePermissionCheck } from "app/services/permissions/usePermissionCheck";

export function useNavigationMenuFilter() {
  const pathName = usePathname();
  const { checkPermission } = usePermissionCheck();

  const menuItems = useMemo(() => {
    const menuItemsFiltered = NAVIGATION_MENU_ITEMS.filter(
      (item) => !item.permission || checkPermission(item.permission),
    ).map((item) => {
      const pathSegments = pathName.split("/").filter(Boolean);
      const itemSegments = item.path.split("/").filter(Boolean);
      const isActive =
        pathName === item.path || pathSegments[0] === itemSegments[0];

      return {
        ...item,
        active: isActive,
      };
    });

    const menuItemsGrouped = menuItemsFiltered.reduce(
      (acc, item) => {
        const group = item.group || "";
        if (!acc[group]) {
          acc[group] = [];
        }
        acc[group].push(item);
        return acc;
      },
      {} as Record<string, typeof menuItemsFiltered>,
    );

    return Object.values(menuItemsGrouped);
  }, [pathName, checkPermission]);

  return menuItems;
}
